// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { Container } from 'components/organizations/layout'
import { CONTENT_PAGES, useNewEmptyStates } from 'features/empty_state'
import { fetchStatistics } from 'features/organization_statistics'
import { useIsSettingsModalLayout } from 'features/settings_modal/layout_context'
import { UpgradeBanner } from 'features/upgrade_banner'
import { UsersPeoplePageHeader } from 'features/users_page/users_people_page_header'

import { List } from './list'

export const Page = () => {
  const dispatch = useDispatch()
  const inSettingsModal = useIsSettingsModalLayout()
  const isNewEmptyStatesEnabled = useNewEmptyStates()
  const { pathname } = useLocation()

  useEffect(() => {
    dispatch(fetchStatistics())
  }, [dispatch, pathname])

  return (
    <>
      {!inSettingsModal && <UsersPeoplePageHeader variant="standalone" />}
      <Container>
        {isNewEmptyStatesEnabled && <UpgradeBanner featureKey="organization_invitation" contentKey={CONTENT_PAGES.users} />}
        <List />
      </Container>
    </>
  )
}
